module.exports = __webpack_public_path__ + "static/img/tery_sms.d3a13d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tery_sms.png
// module id = vqBm
// module chunks = 1